<template lang="html">
  <div id="logo">
    <!-- <a href="#" v-scroll-to="'#intro'"> -->
      <img v-for="(image, index) in this.logos" ref="ahaMarks" :class="{ active: index == 0}" :key="image.id" :src="image.url" alt="">
    <!-- </a> -->
    <img v-if="defaultImg" class="defaultImg" src="../assets/images/00_Fragezeichen.svg" alt="">
  </div>
</template>

<script>
export default {
  data () {
    return {
      path: null,
      increment: 50,
      scrollIndex: 0,
      logos: [],
      defaultImg: false
    }
  },
  computed: {
    images () {
      return this.$store.getters.getPageByUID('home')
    }
  },
  created () {
    window.addEventListener('scroll', this.changeQuestion)
  },
  destroyed () {
    window.removeEventListener('resize', this.loadLogos)
    window.removeEventListener('scroll', this.changeQuestion)
  },
  mounted () {
    this.loadLogos()
    window.addEventListener('resize', this.loadLogos)
  },
  methods: {
    loadLogos () {
      let pageHeight = document.querySelector('main').clientHeight
      this.scrollIndex = Math.ceil(pageHeight / this.increment)
      let logoSource = this.images.files
      let duplicateNumber = this.scrollIndex / logoSource.length
      for (var index = 0; index < duplicateNumber; index++) {
        this.logos.push(...logoSource)
      }
    },
    changeQuestion (event) {
      let scrollPos = window.pageYOffset
      let images = this.$refs.ahaMarks
      let increment = 100
      let festival = document.getElementById('festival')
      let startPos = festival.querySelector('.aha-info').offsetTop - (window.innerHeight / 2)
      let endPos = festival.clientHeight + startPos
      let infokontakt = document.getElementById('aha-infokontakt')
      let startTwoPos = infokontakt.querySelector('#kontakt').offsetTop - (window.innerHeight / 2)
      let endTwoPos = infokontakt.clientHeight + startTwoPos
      if (scrollPos < startPos) {
        for (var i = 0; i < images.length; i++) {
          images[i].classList = ''
        }
        images[0].classList.add('active')
        this.defaultImg = false
      } if (scrollPos > startPos && scrollPos < endPos) {
        for (var index = 0; index < images.length; index++) {
          let pos = index * increment
          let pos2 = (index + 1) * increment
          if (scrollPos > pos && scrollPos < pos2) {
            images[index].classList.add('active')
          } else {
            images[index].className = ''
          }
        }
        this.defaultImg = false
      } if (scrollPos > endPos && scrollPos < startTwoPos) {
        for (var i2 = 0; i2 < images.length - 5; i2++) {
          images[i2].classList = ''
        }
        this.defaultImg = true
      } if (scrollPos > startTwoPos && scrollPos < endTwoPos) {
        for (var index2 = 0; index2 < images.length; index2++) {
          let pos = index2 * increment
          let pos2 = (index2 + 1) * increment
          if (scrollPos > pos && scrollPos < pos2) {
            images[index2].classList.add('active')
          } else {
            images[index2].className = ''
          }
        }
        this.defaultImg = false
      }
      if (scrollPos === 0) {
        images[0].classList.add('active')
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

#logo {
  width:50%;
  height:100%;
  position:fixed;
  z-index:1;
  top:0;
  left:0;
  @media only screen and (max-width: $tablet) {
    // width:40%;
  }
  img {
    max-width:100%;
    max-height:100%;
    display:none;
    position:absolute;
    top:50%;
    transform:translate(0, -50%) scale(1);
    &.active, &.defaultImg {
      display:block;
    }
  }
}
</style>
